import { normalizeToken } from "./searchTokens";
import { PROFILE_TEXT_MAX_LENGTH, trimAndLimitProfileText } from "./profileText";

const RESERVED_PUBLIC_HANDLES = new Set([
  "admin",
  "api",
  "app",
  "help",
  "me",
  "profile",
  "settings",
  "signin",
  "signup",
  "support",
]);

export function isEmailStyleUserName(userName = "") {
  const value = trimAndLimitProfileText(userName);
  return value.includes("@");
}

export function getPublicHandle(userName = "") {
  const raw = trimAndLimitProfileText(userName);
  if (!raw) return "";

  const base = isEmailStyleUserName(raw) ? raw.split("@")[0] : raw;
  const normalized = normalizeToken(base).replace(/\s+/g, "").replace(/[^a-z0-9._-]/g, "");
  return normalized.slice(0, PROFILE_TEXT_MAX_LENGTH);
}

export function normalizePublicHandle(handle = "") {
  return getPublicHandle(handle);
}

export function isReservedPublicHandle(handle = "") {
  return RESERVED_PUBLIC_HANDLES.has(normalizePublicHandle(handle));
}

export function derivePublicHandleCandidate({ publicHandle = "", userName = "", email = "" } = {}) {
  const source =
    trimAndLimitProfileText(publicHandle) ||
    trimAndLimitProfileText(userName) ||
    trimAndLimitProfileText(email);
  return normalizePublicHandle(source);
}

export function matchesPublicHandle(userName = "", handle = "") {
  const normalizedHandle = normalizePublicHandle(handle);
  if (!normalizedHandle) return false;
  return getPublicHandle(userName) === normalizedHandle;
}

export function getPublicProfilePathByHandle(handle = "") {
  const normalizedHandle = normalizePublicHandle(handle);
  return normalizedHandle ? `/u/${normalizedHandle}` : "";
}

export function getProfilePathByUid(uid = "") {
  const value = String(uid || "").trim();
  return value ? `/profile/${value}` : "";
}
